export interface NetworkConnectionInfo {
  effective_type?: string;
  downlink?: number;
  rtt?: number;
  save_data?: boolean;
  type?: string;
  downlink_max?: number;
}

export interface NavigatorWithDeviceContext extends Navigator {
  deviceMemory?: number;
  connection?: {
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
    saveData?: boolean;
    type?: string;
    downlinkMax?: number;
  };
}

export const ONBOARDING_OAUTH_KEY = 'vennie_onboarding_oauth';

export type OnboardingOAuthPhase = 'shopify' | 'zendesk' | 'gorgias' | 'success';

export interface TermsAcceptanceBrowserContext {
  browser_timestamp: string;
  timezone?: string;
  locale: string;
  languages: readonly string[];
  platform: string;
  vendor: string;
  screen_size: {
    width: number;
    height: number;
    color_depth: number;
    pixel_depth: number;
  };
  viewport_size: {
    width: number;
    height: number;
  };
  device_pixel_ratio: number;
  touch_capability: {
    max_touch_points: number;
    ontouchstart: boolean;
  };
  hardware_concurrency?: number;
  device_memory?: number;
  network_connection_info?: NetworkConnectionInfo;
  current_url: string;
  current_path: string;
  referrer: string;
}
